import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

import registrationModule from './modules/registrationModule'
import headerModule from './modules/headerModule'
import dashboardModule from './modules/dashboardModule'
import alertModule from './modules/alertModule'
import customerModule from './modules/customerModule'
import addpacksModule from './modules/productModule/addpacksModule'
import renewModule from './modules/productModule/renewModule'
import modifyModule from './modules/productModule/modifyModule'
import bulkModule from './modules/productModule/bulkModule'
import deviceModule from './modules/deviceModule'
import reportModule from './modules/reportModule'
import downloadModule from './modules/downloadModule'
import cartSubscribeModule from './modules/cartSubscribeModule'
//import scheduleBasePackModule from './modules/scheduleBasePackModule'


export const store = new Vuex.Store({
    state: {
        name: 'SSC LCO Portal',
        version: 'v1.0.04',
        mode: "production",
        baseUrl: 'https://lcoportal.sscnxtdigital.in',
        firebaseUrl: 'https://imcl-lco-35e48.firebaseio.com',
        userInfo: undefined,
        subuserInfo: undefined,
        SubscriberDetails: undefined,
        getCartDetails: {},
        pageNameProduct: '',
        AutoRenewItem: {},
        getCustomerNumber: undefined,
        getCheckoutDetails: {},
        getSideNavInfoDetails: '',
        ReportQueueing: {},
        invoiceCartDetails: {},
        sideNav: true,
        customerEnteredId: '',
        uniqueCustomerId: '',
        showAllModule: '',
        portalCode: 'A',
        ottVerifiedUsers: {},
        changeBasePack: {},
        changeValidity: {},
        scheduleBasePack: {},
        SMSTemplates: [{smsid:'SMS1',content:'Dear Subscriber, Your  INDigital cable TV pack is due to expire in next 5 days. Please contact your local cable operator OR call us on 1800 266 6456 to avoid service disruption',displayText:'Expiring in next 5 days'},{smsid:'SMS2',content:'Dear Subscriber, Your  INDigital cable TV pack is due to expire in next 3 days. Please contact your local cable operator OR call us on 1800 266 6456 to avoid service disruption',displayText:'Expiring in next 3 days'},{smsid:'SMS3',content:'Dear Subscriber, Your  INDigital cable TV pack is due to expire TOMORROW. Please contact your local cable operator OR call us on 1800 266 6456 to avoid service disruption',displayText:'Expiring tomorrow'},{smsid:'SMS4',content:'Dear Subscriber, Your INDigital cable TV subscription HAS EXPIRED. Please contact your local cable operator OR call us on 800 266 6456 to RENEW',displayText:'Expired'}],
        verifiedBroadbandCustomer: false
    },
    getters,
    mutations,
    actions,
    modules: {
        registrationModule,
        headerModule,
        dashboardModule,
        alertModule,
        customerModule,
        addpacksModule,
        renewModule,
        modifyModule,
        bulkModule,
        deviceModule,
        reportModule,
        downloadModule,
        cartSubscribeModule
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js